import { render, staticRenderFns } from "./DishTotal.vue?vue&type=template&id=08d6705e&"
import script from "./DishTotal.vue?vue&type=script&lang=js&"
export * from "./DishTotal.vue?vue&type=script&lang=js&"
import style0 from "./DishTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports